import { AppButton, AppTextField } from 'components';
import useQuizQuestions from 'hooks/API/GET/useQuizQuestions';
import useDebounce from 'hooks/useDebounce';
import { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
// import { HiPencil } from 'react-icons/hi';
// import { AiOutlineDelete } from 'react-icons/ai';
import QuestionDeleteModal from './QuestionDeleteModal';
// import DOMPurify from 'dompurify';
// import { VscOpenPreview } from 'react-icons/vsc';
import QuestionPreviewModal from './QuestionPreviewModal';
import TablePaginate from 'components/Paginate';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import AccordionListing from './AccordionListing';
import useSource from './manage/useSource';
import CopyContentsModal from 'pages/manage-assess-perform/CopyContentsModal';
import useQuizQuestionClone from 'hooks/API/POST/useQuizQuestionClone';
import useQueryParams, { QueryParamsAsString } from 'hooks/useQueryParams';
import useNodeHighlighter from 'hooks/useNodeHighlighter';
import { keyMapper } from 'pages/manage-assess-perform';
import QuestionCommentDropBox from './QuestionCommentDropBox';
import RatingUpdateModal from './RatingUpdateModal';
import SearchTextField from 'components/Inputs/SearchTextField';

function QuizQuestions() {
  const history = useHistory();
  const queryParams = useQueryParams();
  const paperId = queryParams.get('paperId');
  const questionId = queryParams.get('question');

  const queryString = QueryParamsAsString();

  const [params, setParams] = usePaginateDefaults();
  const { classID, courseID, chapterID, quizID } = useParams();
  const [doNotShowList, setDoNotShowList] = useState({ value: false, listIds: [] });
  const [search, handleSearch] = useState('');
  const [deleteQModal, handleDeleteQModal] = useState(Object.assign({}, DELETE_Q_MODAL_CONFIG));
  const [previewMode, handlePreviewMode] = useState(Object.assign({}, PREVIEW_MODAL));
  const [updatingRatingModal, setUpdatingRatingModal] = useState(
    Object.assign({}, RATE_UPDATE_CONFIG)
  );
  const [qBox, setQBox] = useState({ open: false, data: {} });

  const [chapterCopyMode, setChapterCopyMode] = useState({ open: false, data: {} });

  const { isLoading: cloning, mutate: clone } = useQuizQuestionClone({ courseID });

  const searchKeyword = useDebounce(search, 1000);

  const { manageQuizQuestion } = useSource({ paperId });
  const { isLoading: updating, mutate } = manageQuizQuestion;

  const _data = useQuizQuestions({
    enabled: true,
    courseID,
    chapterID,
    quizID,
    configs: { params: { ...params, keyword: searchKeyword, paperId } },
  });
  const { isLoading, data: tableData, isError } = _data;
  const { meta: { page, total } = {} } = tableData?.data ?? {};
  const [listQuestions, setListQuestions] = useState([]);

  const mountCall = useCallback(() => {
    if (Array.isArray(tableData?.data?.result)) {
      let result = tableData?.data?.result.map((m) => {
        m.closedValve = true;
        return m;
      });
      setListQuestions(result);
    }
  }, [tableData?.data?.result]);

  useEffect(() => {
    mountCall();

    return () => {};
  }, [mountCall]);

  function handleQuizQuestion(quizFormData = {}) {
    if (updating) return;

    mutate(quizFormData, {
      onSuccess() {},
    });
  }

  const [expanded, setExpanded] = useState(null);

  const handleAccordChange = (panel) => (event, isExpanded) => {
    setQBox({ open: false, data: {} });

    setExpanded(isExpanded ? panel : null);
  };

  useNodeHighlighter('question');

  useEffect(() => {
    if (questionId) setExpanded(questionId);
  }, [questionId]);

  return (
    <Fragment>
      {qBox.open && (
        <QuestionCommentDropBox
          open={qBox.open}
          data={{ ...qBox?.data }}
          close={() => {
            setQBox({ open: false, data: {} });
          }}
        />
      )}
      {chapterCopyMode.open && (
        <CopyContentsModal
          open={chapterCopyMode.open}
          closeModal={() => {
            setChapterCopyMode({ open: false, data: {} });
          }}
          handleClone={(data = {}) => {
            if (cloning) return;

            clone(data, {
              onSuccess() {
                setChapterCopyMode({ open: false, data: {} });
              },
            });
          }}
          data={chapterCopyMode.data}
        />
      )}
      <QuestionDeleteModal
        modalConfig={deleteQModal}
        closeModal={() => handleDeleteQModal(Object.assign({}, DELETE_Q_MODAL_CONFIG))}
      />
      <QuestionPreviewModal
        state={previewMode}
        closeModal={() => handlePreviewMode(PREVIEW_MODAL)}
      />

      {updatingRatingModal.show && (
        <RatingUpdateModal
          show={updatingRatingModal.show}
          closeModal={() => {
            setUpdatingRatingModal(Object.assign({}, RATE_UPDATE_CONFIG));
          }}
          data={updatingRatingModal.data}
        />
      )}

      <div className="mainWraper">
        <div className="container-fluid" style={{ padding: '2rem' }}>
          <div className="row">
            <div className="col-6">
              <h2 className="prime-head p-0">Manage questions</h2>
              {/* <span></span> */}
              {listQuestions.length > 0 && (
                <Fragment>
                  <div>
                    <input
                      type="checkbox"
                      id="commentBox"
                      className="mx-2"
                      onChange={(event) => {
                        const __checked = event.target.checked;

                        if (!__checked) {
                          setDoNotShowList({ value: false, listIds: [] });

                          mountCall();
                        }

                        if (__checked) {
                          const __filteredQuestions = listQuestions.filter((q) => q.reviewComment);

                          setDoNotShowList({
                            value: true,
                            listIds: __filteredQuestions.map((x) => x._id),
                          });
                        }
                      }}
                    />
                    <label htmlFor="commentBox">
                      Show questions (from the current list) with comments added
                    </label>
                  </div>
                  <div style={{ fontSize: '10px' }}>
                    <span
                      style={{
                        height: '10px',
                        width: '10px',
                        backgroundColor: 'red',
                        display: 'inline-block',
                      }}
                      className="mx-2"
                    ></span>{' '}
                    represents comments added
                    <span
                      style={{
                        height: '10px',
                        width: '10px',
                        backgroundColor: 'green',
                        display: 'inline-block',
                      }}
                      className="mx-2"
                    ></span>{' '}
                    represents comments responded
                  </div>
                </Fragment>
              )}
            </div>
            <div className="col-6 prime-head text-right">
              <AppButton variantClass="btn-plane p--tint mx-2" onClick={history.goBack}>
                &#8701; Back
              </AppButton>
              <Link
                to={`/classes/${classID}/courses/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions/add${queryString}`}
              >
                <AppButton variantClass="btn-plane g--tint">+ Add question</AppButton>
              </Link>
            </div>
          </div>

          <div className="d-flex flex-row-reverse my-4">
            <div>
              <SearchTextField
                size="small"
                inputProps={{
                  placeholder: 'Search for questions...',
                }}
                search={search}
                handleSearch={(search) => handleSearch(search)}
              />
              {/* <AppTextField
                inputProps={{
                  value: search,
                  placeholder: 'Search for questions...',
                  onChange: (event) => handleSearch(event.target.value),
                }}
                labelProps={{
                  label: '',
                }}
              /> */}
            </div>
          </div>

          <div className="___question__acc__rdin">
            {isLoading ? (
              'Loading...'
            ) : isError ? (
              'Failed to load data'
            ) : listQuestions?.length > 0 ? (
              <>
                {(
                  (!doNotShowList.value && listQuestions) ||
                  (doNotShowList.value &&
                    listQuestions.filter((q) => doNotShowList.listIds.includes(q._id)))
                )?.map((result, index) => {
                  return (
                    <AccordionListing
                      key={result._id}
                      total={total}
                      index={(page - 1) * params.limit + index + 1}
                      item={result}
                      accord={{ expanded, handleAccordChange, setQBox }}
                      handleQuizQuestion={(data = {}) =>
                        handleQuizQuestion({ ...data, id: result._id, paperId })
                      }
                      fns={{
                        handleRating: (args = {}) => {
                          setUpdatingRatingModal({ show: true, data: { ...args } });
                        },
                        handleClone: (data = {}) =>
                          clone({
                            classID,
                            courses: [courseID],
                            chapters: [chapterID],
                            quizId: quizID,
                            quizzes: [quizID],
                            questionId: result._id,
                          }),
                        setCopyMode: (__data = {}) => {
                          const args = {};

                          if (result?.quiz?.quizCategory === keyMapper.previous_year) {
                            args.askedInYear = result?.quiz?.askedInYear;
                            args.examBoard = result?.quiz?.examBoard;
                            args.quizCategory = result?.quiz?.quizCategory;
                          }

                          setChapterCopyMode({
                            open: true,
                            data: {
                              classID,
                              courseID,
                              isAssess: true,
                              quizId: quizID,
                              questionId: result._id,
                              isFromQuestions: true,
                              args,
                            },
                          });
                        },
                      }}
                      deleteConfig={{
                        showBtn: true,
                        handleDelete: () => {
                          handleDeleteQModal({
                            show: true,
                            data: { id: result._id },
                          });
                        },
                      }}
                    />
                  );
                })}
              </>
            ) : (
              <>
                {doNotShowList.value ? (
                  <h3 className="text-center">
                    No records was found in the current list that needs to be resolved
                  </h3>
                ) : (
                  <h1 className="text-center">No records found</h1>
                )}
              </>
            )}
          </div>

          <div className="table-responsive mt-4">
            <TablePaginate
              maxCount={total}
              currentPage={page}
              defaultLimit={params.limit}
              setPage={(page) => setParams((x) => ({ ...x, page }))}
              handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const PREVIEW_MODAL = { show: false, questionID: null };
const DELETE_Q_MODAL_CONFIG = {
  show: false,
  data: {
    id: null,
  },
};
const RATE_UPDATE_CONFIG = {
  show: false,
  data: {},
};

export default QuizQuestions;
